import { ifAuthenticated, mustBeJobseeker } from "../util/auth";

const JobseekerSignup = () =>
  import("../components/content/jobseekerportal/signup");

const JobseekerHome = () =>
  import("../components/content/jobseekerportal/home");

const JobseekerProfile = () =>
  import("../components/content/jobseekerportal/profile");

  const JobseekerJobs = () =>
    import("../components/content/jobseekerportal/jobs");

export const JobseekerSignupRoute = {
  path: "/jobseeker-signup",
  component: JobseekerSignup
};

export const JobseekerHomeRoute = {
  path: "/jobseeker-home",
  component: JobseekerHome
};

export const JobseekerProfileRoute = {
  path: "/jobseeker-profile",
  component: JobseekerProfile,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeJobseeker
};

export const JobseekerAvailablejobsRoute = {
  path: "/jobseeker-jobs",
  component: JobseekerJobs,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeJobseeker
};
